<template>
  <div>
    <div class="my-15 container card_container">
      <h3 class="mb-5 titolo"><i class="fas fa-question"></i> FAQ</h3>
      <VueFaqAccordion :items="myItems" questionProperty="domanda" answerProperty="risposta" />
    </div>
  </div>
</template>

<script>
import VueFaqAccordion from "vue-faq-accordion";
import UtilService from "@/services/utilService";
export default {
  components: {
    VueFaqAccordion,
  },
  data() {
    return {
      myItems: [
        {
          domanda: null,
          risposta: null,
        },
      ],
    };
  },
  mounted: function () {
    let me = this;
    me.loadData();
  },
  methods: {
    async loadData() {
      let me = this;
      try {
        const responseFaq = await UtilService.faq();
        if (responseFaq.data.stato === 200) {
          me.myItems = responseFaq.data.data;
        } else {
          me.$bvModal
            .msgBoxOk(responseFaq.data.errore, {
              title: "Errore",
              size: "md",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch(() => {});
        }
      } catch (error) {
        me.$bvModal
          .msgBoxOk(error, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>
